import { render, staticRenderFns } from "./expense.vue?vue&type=template&id=767662db&scoped=true"
import script from "./expense.vue?vue&type=script&lang=js"
export * from "./expense.vue?vue&type=script&lang=js"
import style0 from "./expense.vue?vue&type=style&index=0&id=767662db&prod&lang=scss&scoped=true"
import style1 from "./expense.vue?vue&type=style&index=1&id=767662db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767662db",
  null
  
)

export default component.exports